import { render } from "./user_flashcards_app.vue?vue&type=template&id=4424bf49"
import script from "./user_flashcards_app.vue?vue&type=script&lang=js"
export * from "./user_flashcards_app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__